import { Reveal } from "./Reveal";

export default function SectionHead({ eyebrow, title, description, align = "center" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-3xl ${alignCls} mb-12 sm:mb-16`}>
      <p className="font-mono2 text-xs tracking-[0.25em] text-blue-400 mb-4">{eyebrow}</p>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug text-slate-50">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-400">{description}</p>
      )}
    </Reveal>
  );
}
